define(
({
  "alert": "Avviso",
  "okay": "Okay"
})
);
